import $ from 'jquery'
// import Swiper JS
import Swiper, { Navigation } from 'swiper'

Swiper.use([Navigation])

$(document).ready(dhsv_vc_testimonial_slider())

function dhsv_vc_testimonial_slider() {
  new Swiper('.testimonial-slider', {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 1,
    modules: [Navigation],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })
}
